import { useEffect } from 'react'

import { Button, Tabs, TabsProps } from 'antd'
import { createStyles } from 'antd-style'

import { loginMemberByMfaApi } from '@eastcoal/api/auth/memberLogin/loginMemberByMfa'
import { loginMemberByPasswordApi } from '@eastcoal/api/auth/memberLogin/loginMemberByPassword'
import { loginMemberBySmsApi } from '@eastcoal/api/auth/memberLogin/loginMemberBySms'

import { useUrlHash } from '@eastcoal/common/hooks/useUrlHash'

import { LoginPassword } from '@eastcoal/auth/components/Login/Password'
import { LoginSms } from '@eastcoal/auth/components/Login/Sms'
import { EaQRcodeIcon } from '@eastcoal/icon/EaQRCodeIcon'
import { useNavigate } from '@eastcoal/router/exports/react-router'

import { isValidLoginType, LoginType } from '../../enums/LoginType'
import { useLoginStore } from '../../hooks/useStore'
import { navigateWithTarget } from '../../utils/navigateWithTarget'

const items: TabsProps['items'] = [
  {
    key: LoginType.SMS,
    label: '短信登录',
    children: <LoginSms api={loginMemberBySmsApi} />
  },
  {
    key: LoginType.PASSWORD,
    label: '密码登录',
    children: (
      <LoginPassword
        mfaApi={loginMemberByMfaApi}
        passwordApi={loginMemberByPasswordApi}
      />
    )
  }
]

const useStyles = createStyles(
  ({ token, prefixCls }) => ({
    switchIcon: {
      color: token.blue
    },
    switchBtn: {
      position: 'absolute',
      right: token.marginXS,
      top: token.marginXXS,
      padding: 'unset',
      [`&.${prefixCls}-btn .anticon`]: {
        fontSize: ` ${token.fontSizeHeading2}px`
      }
    }
  }),
  { hashPriority: 'high' }
)

export const LoginTabs = () => {
  const { loginType, setLoginType } = useLoginStore()
  const navigate = useNavigate()
  const hash: any = useUrlHash()

  useEffect(() => {
    setLoginType(isValidLoginType(hash) ? hash : LoginType.WECHAT)
  }, [hash])

  const handleTabsChange = (key: string) => {
    navigateWithTarget(navigate, `#${key}`)
  }

  const handleSwitchWechatLogin = () => {
    navigateWithTarget(navigate, `#${LoginType.WECHAT}`)
  }

  const { styles } = useStyles()

  return loginType !== LoginType.WECHAT ? (
    <div>
      <Tabs
        activeKey={loginType}
        defaultActiveKey={LoginType.SMS}
        items={items}
        onChange={handleTabsChange}
      />
      <Button
        className={styles.switchBtn}
        icon={<EaQRcodeIcon className={styles.switchIcon} />}
        title='扫码登录'
        type='text'
        onClick={handleSwitchWechatLogin}
      />
    </div>
  ) : null
}
